export default __webpack_public_path__ + "locales/en/InviteDialog.json?hash=ecdbdd260fbccd3349b0ff33241cb7b4";